import { useLazyQuery } from '@apollo/client';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import { Icon, IconBus } from '@flixbus/honeycomb-icons-react';
import {
	LegacyAutocomplete as Autocomplete,
	LegacyAutocompleteInput as AutocompleteInput,
	LegacyAutocompleteOptions as AutocompleteOptions,
} from '@flixbus/honeycomb-react';

import { FILTER_TYPES } from 'pages/RideListPage/components/RideFilters/filterConstants';
import { rideFilterStore } from 'pages/RideListPage/components/RideFilters/RideFilterStore';

import { SEARCH_LINES_BY_CODE } from './gql';
import { mapLinesToOptions } from './mapLinesToOptions';
import { LINE_NUMBERS_FILTER_TEXT } from './texts';

import styles from './styles.module.css';

const LineNumbers = observer(() => {
	const [lines, setLines] = useState([]);
	const [inputValue, setInputValue] = useState('');

	const [getLines, { loading }] = useLazyQuery(SEARCH_LINES_BY_CODE, {
		fetchPolicy: 'no-cache',
		onCompleted: (data) => {
			setLines(mapLinesToOptions(data?.searchLinesByCode));
		},
	});

	const onDebounce = (e) => {
		if (!e.target.value) return;
		getLines({ variables: { lineCode: e.target.value } });
	};

	const onSelect = (item) => {
		rideFilterStore.addFilter({ value: item, type: FILTER_TYPES.line });
		setLines([]);
		setInputValue('');
	};

	const checkEmpty = (e) => {
		if (e.target.value === '') {
			setLines([]);
		}
		setInputValue(e.target.value);
	};

	return (
		<Autocomplete
			onDebounce={(e) => onDebounce(e)}
			onChange={(e) => checkEmpty(e)}
			onSelect={(item) => onSelect(item)}
			options={lines}
			value={''}
			id="autocomplete-line"
		>
			<AutocompleteInput
				placeholder={LINE_NUMBERS_FILTER_TEXT.placeholder}
				label={LINE_NUMBERS_FILTER_TEXT.inputLabel}
				loading={loading}
				type="search"
				id="autocomplete-line"
				iconLeft={<Icon InlineIcon={IconBus} />}
				value={inputValue}
			/>
			<AutocompleteOptions
				appearance="boxed"
				renderOption={(option) => (
					<div className={styles.option} key={option.key}>
						<span className={styles.code}>{option.code}</span>
						<span className={styles.name}>{option.title}</span>
					</div>
				)}
				label={LINE_NUMBERS_FILTER_TEXT.optionsLabel}
				optionsToDisplay={5}
			/>
		</Autocomplete>
	);
});
export default LineNumbers;
